import { ApiBase } from '@/api/methods/ApiBase'

export namespace SessionsApi {
  /**
   * セッション確認(期限切れの場合は例外が発生)
   */
  export async function check(): Promise<void> {
    await ApiBase.get('/auth/sessions')
  }
}
